export const TEMPLATE = 'TEMPLATE'

export function template(currentTemplate) {
  return {
    payload: currentTemplate,
    type: TEMPLATE,
  }
}
